/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponseString
 */
export interface ResponseString {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseString
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseString
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseString
     */
    data?: string;
}

/**
 * Check if a given object implements the ResponseString interface.
 */
export function instanceOfResponseString(value: object): value is ResponseString {
    return true;
}

export function ResponseStringFromJSON(json: any): ResponseString {
    return ResponseStringFromJSONTyped(json, false);
}

export function ResponseStringFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseString {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : json['data'],
    };
}

export function ResponseStringToJSON(json: any): ResponseString {
    return ResponseStringToJSONTyped(json, false);
}

export function ResponseStringToJSONTyped(value?: ResponseString | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'],
    };
}

